import script from "./update-locked-template-versions-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./update-locked-template-versions-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__